import { render, staticRenderFns } from "./TblDetailComment.vue?vue&type=template&id=ddb1b41c&scoped=true&"
import script from "./TblDetailComment.vue?vue&type=script&lang=js&"
export * from "./TblDetailComment.vue?vue&type=script&lang=js&"
import style0 from "./TblDetailComment.vue?vue&type=style&index=0&id=ddb1b41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb1b41c",
  null
  
)

export default component.exports